<!-- 由 suu 创建于 2022-01-19 星期三 -->
<template>
  <div class="recipe-feedbackStatus">
    <div class="status">
      <div class="success">
        <div class="iconfont icon-gou">
          <van-icon name="success" />
        </div>
        <div class="text">提交成功!</div>
      </div>
    </div>
    <div class="line"></div>
    <div class="content">
      <div class="info">感谢您的反馈</div>
      <div v-if="s_from !== '兑换码领取(转介)'">
        <div class="desc">长按下方二维码，领取明星减脂营<text class="red">50</text>元优惠券</div>
      <div class="qrcode-container">
        <!-- v-longpress 为全局长按事件指令 -->
        <img class="qrcode-image" :src="qrcodeUrl" v-longpress="saveImage"></img>
      </div>
      </div>
      <div class="answer-content">
        <div class="answer-title">反馈内容</div>
        <div class="answer-text" v-for="(item, index) in feedbackData" :key="index">
          <div v-if="item.field_type == 'radio'">
            <div class="answer-item">{{index + 1}}、{{item.field_title}}</div>
          <div class="answer-item answer">【{{item.selectValue || item.value}}】</div>
          </div>
          <div v-else>
            <div class="answer-item">{{index + 1}}、{{item.field_title}}</div>
          <div class="answer-item answer">【{{item.value}}】</div>
          </div>
        </div>
      </div>
      <div class="back-btn" catchtap="backPage">返回</div>
    </div>
    <van-action-sheet
  v-model="show"
  :actions="actions"
  @select="onSelect"
  cancel-text="取消"
  close-on-click-action
/>
  </div>
</template>

<script>
export default {
  name: 'recipe-feedbackStatus',

  components: {},

  props: {},

  data() {
    return {
      show: false,
      actions: [{ name: '保存图片' }],
      qrcodeUrl:
        'https://cdnvue.gymcity.com.cn/uploads/8f8ccf627ccff3e51498e2abbb769e48.png',
      feedbackData: [],
      s_from: this.$route.query.s_from
    }
  },

  computed: {},

  watch: {},

  created() {
    this.feedbackData =
      (sessionStorage.getItem('feedbackData') &&
        JSON.parse(sessionStorage.getItem('feedbackData'))) ||
      []
    // sessionStorage.removeItem('feedbackData')
  },

  mounted() {},

  destroyed() {},

  methods: {
    // 点击保存图片
    onSelect(e) {
      // app
      if (e.name == '保存图片') {
        this.$betterwe.onAppSaveImage({
            data: this.qrcodeUrl, //分享的具体数据
            //分享的数据的格式
            //type=base64  表示图片格式是base64   type=url  表示图片格式是链接
            type: 'url'
          })
      }
    },
    // 长按二维码
    saveImage() {
      this.show = true
    },
    backPage() {
      this.$router.back()
    }
  }
}
</script>

<style lang='scss' scoped>
@function vw($px) {
  @return ($px / 750) * 100vw;
}
.recipe-feedbackStatus {
  width: 100%;
  overflow: hidden;
  background-color: #fff;
  min-height: 100vh;
  padding: vw(0) vw(40);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  .status {
    margin-top: vw(50);
    margin-bottom: vw(30);
  }
  .success,
  .fail {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  .iconfont {
    width: vw(96);
    height: vw(96);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: vw(60);
    color: #fff;
    margin-bottom: vw(20);
  }
  .icon-gou {
    background-color: #35c763;
  }
  .icon-cha {
    background-color: #f04646;
  }
  .status .text {
    font-size: vw(40);
    font-weight: 600;
    color: #000;
  }

  .line {
    width: vw(562);
    height: vw(4);
    background-color: #f2f2f2;
    margin: 0 auto;
    margin-bottom: vw(30);
  }
  .info {
    text-align: center;
    font-size: vw(30);
    line-height: vw(40);
    color: #000000;
    margin-bottom: vw(8);
  }
  .desc {
    margin-bottom: vw(28);
    text-align: center;
    font-size: vw(24);
    line-height: vw(40);
    color: #000000;
  }
  .red {
    color: #ff0000;
  }
  .content {
    width: 100%;
  }
  .qrcode-container {
    margin: 0 auto;
    width: vw(376);
    height: vw(376);
    background-color: rgb(240, 240, 240);
    border-radius: vw(10);
    padding: vw(16);
    box-sizing: border-box;
  }
  .qrcode-image {
    width: 100%;
    height: 100%;
  }
  .answer-content {
    position: relative;
    width: vw(610);
    margin: 0 auto;
    border: vw(2) dashed #bcbcbc;
    border-radius: vw(20);
    padding: vw(42) vw(34);
    box-sizing: border-box;
    margin-top: vw(44);
    margin-bottom: vw(72);
  }
  .answer-title {
    width: vw(158);
    text-align: center;
    font-size: vw(28);
    height: vw(34);
    line-height: vw(34);
    background-color: #ffffff;
    position: absolute;
    left: 50%;
    top: 0;
    z-index: 10;
    transform: translate(-50%, -50%);
  }
  .answer-text {
    line-height: vw(34);
    font-size: vw(24);
    color: rgba(32, 32, 37, 0.5);
  }
  .answer-item {
    margin-bottom: vw(8);
  }
  .answer {
    text-indent: vw(30);
  }
  .back-btn {
    text-align: center;
    height: vw(72);
    line-height: vw(72);
    border-radius: vw(20);
    border: solid vw(2) #f1f1f1;
    margin-bottom: vw(150);
    font-size: vw(30);
    font-weight: 600;
  }
}
</style>